import React from "react";

import { TableCell } from "../../UI/TableCell";
import { TableRow } from "../../UI/TableRow";

import { dateToMMDDYY, getDate } from "../../common/date_utils";
import { ModalProvider } from "../../contexts/ModalContext";
import { UserNameLink } from "../UserNameLink";
import { Button } from "../../UI/Button";
import { URL } from "../../constants/navigation";
import { NoRegisterUserActions } from "./NoRegisterUserActions";

interface IProps {
  isGlobalSearch: boolean;
  user: Record<string, any>;
}

export const UserInviteSearchResultsTableBodyRow: React.FC<IProps> = (props) => {
  let l2Name = props.user.l2IdName || "N/A";
  let l3Name = props.user.l3IdName || "N/A";
  let l4Name = props.user.l4IdName || "N/A";

  const handleLoginMethodClick = () => {
    window.open(`${URL.USER.replace(":id", props.user.id)}`, "_blank");
  };

  return (
    <TableRow>
      <TableCell>
        <ModalProvider>
          <UserNameLink openNewTab name={props.user.name} id={props.user.id} />
        </ModalProvider>
      </TableCell>
      <TableCell>{props.user.email}</TableCell>
      <TableCell>{l2Name}</TableCell>
      <TableCell>{l3Name}</TableCell>
      <TableCell>{l4Name}</TableCell>
      <TableCell>{props.user.createdDate && dateToMMDDYY(getDate(props.user.createdDate))}</TableCell>
      <TableCell>{props.user.registered ? "Yes" : "No"}</TableCell>
      <TableCell>
        {!props.user.registered && (
          <ModalProvider>
            <NoRegisterUserActions />
          </ModalProvider>
        )}
        {props.user.registered && (
          <Button onClick={handleLoginMethodClick} appearance="primary">
            View Login Method
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};
